import React from 'react';

import { getTime, translateTransationType } from 'utils/helpers';
import { AutomatonNameCell } from 'components/shared';

export default [
    {
        title: 'ID автомата',
        dataIndex: 'automatonId',
        key: 'automatonId',
        render: text => <div className="cell">{text}</div>,
    },
    {
        title: 'Назва автомата',
        dataIndex: 'automaton',
        key: 'automaton.name',
        render: automaton => <AutomatonNameCell automaton={automaton} />,
    },
    {
        title: 'Тип транзакції',
        dataIndex: 'type',
        key: 'type',
        render: text => <div className="cell">{translateTransationType(text)}</div>,
    },
    {
        title: 'Кількість води',
        dataIndex: 'water',
        render: text => <div className="cell">{text} л.</div>,
    },
    {
        title: 'Користувач',
        dataIndex: 'user.firstName',
        key: 'user.firstName',
        render: text => <div className="cell">{text || '---'}</div>,
    },
    {
        title: 'Дата',
        dataIndex: 'date',
        key: 'date',
        render: isoDate => {
            const [date, time] = getTime(isoDate);
            return <div className="cell">{date} {time}</div>;
        }
    },
];
